const DateInterval = {
  P1D: 'daily',
  P7D: 'weekly',
  P1M: 'monthly',
  P1Y: 'yearly',
};

export default DateInterval;
